import ko from "knockout";

const referenceObservable = ko.observable();

export default function reflectCustomProperties(source: KnockoutObservable<any>, target: any) {
    const sourceAny = source as any;
    Object.keys(source).forEach(property => {
        // If nonstandard (for observable) property that doesn't already exist on target, we will copy it from source
        if (
            !Object.prototype.hasOwnProperty.call(referenceObservable, property) &&
            !Object.prototype.hasOwnProperty.call(target, property)
        ) {
            if (typeof sourceAny[property] === "function" && !ko.isObservable(source)) {
                // We will try to retain calling context of functions that aren't observables
                target[property] = function (...params: any[]) {
                    return sourceAny[property](...params);
                };
            } else {
                target[property] = sourceAny[property];
            }
        }
    });
}
